import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const customerIo = defineConnector({
  identifier: "customerIo",
  name: "Customer.io",
  tagLine: "Marketing automation platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: () => "https://(api|track|beta-api)\\.customer\\.io/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get your Customer.io API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Customer.io, go to **Settings > Account Settings > API Credentials** and create a new App API key or use your existing one.",
        },
      ],
    },
    {
      title: "Enter your API key",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.customer.io/v1/accounts/region",
  },
});
